<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true }
  },
  methods: {
    async getData(form) {
      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandDashboardApi({ ...form, ...this.page })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
  },
}
</script>
